import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
if (process.env !== 'production') {
  console.warn('warn : DEPRECATED, use GlobalTitle instead');
}

export default {
  props: {
    title: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      required: true
    }
  }
};